import { ReferralProgram } from 'modules/strapi/types';

import { Buttons } from './components/Buttons';
import { Greeting } from './components/Greeting';
import {
  IReferralFlowDialogProps,
  ReferralFlowDialog,
} from '../ReferralFlowDialog';

export interface IWelcomeDialogProps extends IReferralFlowDialogProps {
  hasActivateButton?: boolean;
  isActivating?: boolean;
  onActivateButtonClick: () => Promise<void>;
  onSignInButtonClick: () => void;
  referralProgram: ReferralProgram | undefined;
}

export const WelcomeDialog = ({
  hasActivateButton,
  isActivating,
  onActivateButtonClick,
  onSignInButtonClick,
  referralProgram,
  ...dialogProps
}: IWelcomeDialogProps) => {
  const { onClose } = dialogProps;

  return (
    <ReferralFlowDialog {...dialogProps}>
      <Greeting referralProgram={referralProgram} />
      <Buttons
        hasActivateButton={hasActivateButton}
        isActivating={isActivating}
        onActivateButtonClick={onActivateButtonClick}
        onCancelButtonClick={onClose}
        onSignInButtonClick={onSignInButtonClick}
        referralProgramName={referralProgram?.name}
      />
    </ReferralFlowDialog>
  );
};
